// extracted by mini-css-extract-plugin
export default {"link":"ProjectDocumentsPage_link__VAt37"};